module.exports = __webpack_public_path__ + "static/img/dcjmbxz.6cc75fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dcjmbxz.png
// module id = VyuR
// module chunks = 1